<ng-container *ngIf="!enableDashboardV2Template; then defaultTemplate else v2Template"></ng-container>

<ng-template #defaultTemplate>
  <surf-header class="l-page__header"
              [emulationInProgress]="emulationInProgress"
              [emulatingUser]="emulatingTradeClient"
              [isStartEmulationOptionAvailable]="true"
              [enableCacheUrlRedirect]="true"
              [enableCurrencyDropDown]="ENABLE_B2B_HEADER_CURRENCY_DROPDOWN"
              (startStopEmulation)="startStopEmulation($event)"
              (onSelectBrand)="selectBrand($event)"
              (openAndCloseSurfClientSearchModal)="openAndCloseSurfClientSearchModal($event)"
              (onSelectCurrency)="selectCurrency($event)"
  ></surf-header>

  <main class="l-page__main">
    <section class="dashboard">
      <surf-toaster-notification
        [hasConfirmButton]="true"
        [hasCancelButton]="true"
        [hasDuration]="false"
        [confirmLabel]="'View Quote'"
        [cancelLabel]="'Dismiss'"
        [duration]="10000"
        [message]="'Quote is successfully saved.'"
        [shortMessage]="'Quote ID '+bkgId"
        [active]="activeToaster"
        (actionItem)="onclickActionItem($event)"
      ></surf-toaster-notification>
      <div class="dashboard__search-block">

        <div class="l-wrapper dashboard__search-block-wrapper">
          <div class="dashboard__notify-box" *ngIf="stateCreditUser && clientCreditLimit && clientCreditLimit.remainingTotalCredit">
            <div class="c-msg-strip c-msg-strip--info">
              <div class="c-msg-strip__text">
                <svg class="a-icon c-msg-strip__icon">
                  <use xlink:href="#credit-card"></use>
                </svg>
                <div>Your credit balance is <span class="ts-bold">{{remainingTotalCredit}}</span></div>
              </div>
              <button class="a-btn a-btn--outline/primary c-msg-strip__btn" (click)="getTradeClientCreditAmount(true)"
                      [ngClass]="{'is-loading': showLoader}">
                <svg class="a-icon u-rmr">
                  <use xlink:href="#refresh"></use>
                </svg>
                Refresh
              </button>
            </div>
          </div>
          <div class="dashboard__search-bar auto-search-panel">
            <surf-search-panel (searchFlow)="selectSearchFlow($event)"></surf-search-panel>
          </div>
          <div class="dashboard__search-box" *ngIf="showSearchBar" [class.dashboard__search-box--restricted]="!canUserViewBookings()">
            <surf-linking-itineraries [loadAllResultsAsDefault]="true" [isLinkItinerary]="false" (popupClosed)="resetSelectedOption()"></surf-linking-itineraries>
          </div>
        </div>
      </div>

      <div *ngIf="activeSearchFlow == 'PKG'" class="dashboard__search-expand">
        <div class="l-wrapper">
          <surf-package-criteria></surf-package-criteria>
        </div>
      </div>

      <div *ngIf="activeSearchFlow == 'HTL'" class="dashboard__search-expand">
          <div class="l-wrapper">
            <surf-hotel-criteria-dp [isDPSearch]="false" [setRoomWise]="ENABLE_ROOM_WISE"></surf-hotel-criteria-dp>
          </div>
      </div>

      <!-- <div *ngIf="activeSearchFlow == 'FLT'" class="dashboard__search-expand">
        <div class="l-wrapper">
          <surf-flight-criteria-dp
            [isDPSearch]="false"
            (fltGrabPnrResFromFltCriteria) = "setFlightGrabPnrResult($event)"
            (showManualItemConfigOut) = "setManualItemConfigPnr($event)"
            (pnrComOutputFromFltCriteria) = "setGrabPNRCriteria($event)"
          ></surf-flight-criteria-dp>
        </div>
      </div> -->
      <div *ngIf="activeSearchFlow == 'CAR'" class="dashboard__search-expand">
        <div class="l-wrapper">
          <surf-car-criteria-dp [isDPSearch]="false"></surf-car-criteria-dp>
        </div>
      </div>

      <div *ngIf="activeSearchFlow == 'DP'" class="dashboard__search-expand">
        <div class="l-wrapper">
          <surf-dp-criteria [keyControls]="getKeyControls()"></surf-dp-criteria>
        </div>
      </div>

      <div *ngIf="activeSearchFlow == 'TRS'" class="dashboard__search-expand">
        <div class="l-wrapper">
          <surf-transfer-criteria-dp [isDPSearch]="false"></surf-transfer-criteria-dp>
        </div>
      </div>

      <div *ngIf="activeSearchFlow == 'CRU'" class="dashboard__search-expand">
        <div class="l-wrapper">
          <surf-cruise-criteria-dp></surf-cruise-criteria-dp>
        </div>
      </div>
      <div *ngIf="activeSearchFlow == 'TOU'" class="dashboard__search-expand">
        <div class="l-wrapper">
          <surf-tour-criteria-dp
            [keyControls]="getKeyControls()"
          ></surf-tour-criteria-dp>
        </div>
      </div>

      <div *ngIf="activeSearchFlow == 'GEN'" class="dashboard__search-expand">
        <div class="l-wrapper">
          <surf-generic-criteria-dp></surf-generic-criteria-dp>
        </div>
      </div>

      <surf-add-manual-item [isActive]="activeSearchFlow == 'MAN'" [keyControls]="getKeyControls()"></surf-add-manual-item>

      <surf-add-manual-booking-item
        *ngIf="showManualItemConfig || showManualItemConfigPnr"
        [isActive]="activeSearchFlow == 'MANFLT' || activeSearchFlow == 'MAN_CRU' || showManualItemConfigPnr"
        [productCode]="showManualItemConfigPnr? 'FLT':activeMBIProductCode"
        [isDashboard]="true"
        [pnrComponentOutput]="pnrComOutput"
        [flightGrabPnrResult] = "flightGrabPnrResult"
        [isPnr]="showManualItemConfigPnr"
        [keyControls]="getKeyControls()"
        [changePassengersEnabled]="showManualItemConfigPnr? false:true"
        (emitOnClose)="setManualItemConfigPnr(!$event)">
      </surf-add-manual-booking-item>
      <surf-add-insurance *ngIf="showManualItemConfig" [isFromDashBoard]="true" [keyControls]="getKeyControls()"  [isActive]="activeSearchFlow == 'INS'" [productCode]="'INS'" [changePassengersEnabled]="true" ></surf-add-insurance>

      <ng-template [ngIf]="activeSearchFlow == null">
      <surf-booking-summary [resetTotalBookingsResult]="resetTotalBookingsResult"></surf-booking-summary>
      </ng-template>
  <!--    -->

    </section>
  </main>
  <surf-modal
    [active]="isSurfClientSearchModalActive"
    [contentClass]="'c-client-search_modal'"
    [hasCancelButton]="false"
    [hasConfirmButton]="false"
    [disableConfirm]="false"
    (clickButton)="handleSurfClientSearchModal($event)">

    <surf-client-search-modal
      (openAndCloseSurfClientSearchModal)="openAndCloseSurfClientSearchModal($event)"
      (selectClient)="selectTheEmulatingClient($event)"
    >
    </surf-client-search-modal>
  </surf-modal>

  <!-- Emulation warning message box -->
  <surf-message-box [title]="'Please Note'"
                    [active]="activeEmulationWarning"
                    [hasConfirmButon]="true"
                    [hasCancelButton]="true"
                    [confirmLabel]="'Proceed'"
                    [cancelLabel]="'Cancel'"
                    [svgName]="'exclamation'"
                    [type]="'warning'"
                    (clickButton)="handleEmulationWarning($event)">
    <span>{{EmulationWarningText | surfTextCase: 'sentence'}}</span>
  </surf-message-box>
  <surf-footer [version]="version"></surf-footer>
</ng-template>


<ng-template #v2Template>
  <surf-b2b-dashboard-v2
    [currentImageUrl]="initBackgroundImg">
  </surf-b2b-dashboard-v2>
</ng-template>
